module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/013-italy-ea0a8bd58608236e69917ea1f9356ad2.svg";